import {
    COLLECTION_FAILURE,
    COLLECTION_REQUEST,
    COLLECTION_SUCCESS,
    EXPORT_WIDGET_TO_CSV_FAILURE,
    EXPORT_WIDGET_TO_CSV_REQUEST,
    EXPORT_WIDGET_TO_CSV_SUCCESS,
    RESET_WIDGET_TABLE_COLUMN,
    TOGGLE_WIDGET_TABLE_COLUMN,
} from './types/dashboard-action-types';

import DashboardService from '../../common/services/dashboard-service';

function requestCollections( params ){
    return {
        params,
        type: COLLECTION_REQUEST,
    };
}
function receiveCollections( data ){
    return {
        payload: data,
        type: COLLECTION_SUCCESS,
    };
}
function collectionsRequestError( error ){
    return {
        error,
        type: COLLECTION_FAILURE,
    };
}

export function fetchCollections( params ){
    return ( dispatch, getState, { CONFIG_API } ) => {
        dispatch( requestCollections( params ) );

        const dashboardService = new DashboardService( CONFIG_API );

        return dashboardService.fetchCollections( params )
            .then(
                ( response ) => dispatch( receiveCollections( response ) ),
                ( error = {} ) => {
                    return dispatch( collectionsRequestError( error.response ) );
                }
            );
    };
}

export function exportToCSV( widgetId ){
    return {
        type: EXPORT_WIDGET_TO_CSV_REQUEST,
        widgetId
    };
}

export function exportToCSVSuccess( widgetId ){
    return {
        type: EXPORT_WIDGET_TO_CSV_SUCCESS,
        widgetId
    };
}

export function exportToCSVFailure( widgetId, error ){
    return {
        error,
        type: EXPORT_WIDGET_TO_CSV_FAILURE,
        widgetId,
    };
}

export function toggleWidgetTableColumn( widgetId, columnId ){
    return {
        columnId,
        type: TOGGLE_WIDGET_TABLE_COLUMN,
        widgetId,
    };
}

export function resetWidgetTableColumn( widgetId ){
    return {
        type: RESET_WIDGET_TABLE_COLUMN,
        widgetId,
    };
}

